import { render, staticRenderFns } from "./UserInfoCallBack.vue?vue&type=template&id=60b37901&scoped=true&"
import script from "./UserInfoCallBack.vue?vue&type=script&lang=ts&"
export * from "./UserInfoCallBack.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoCallBack.vue?vue&type=style&index=0&id=60b37901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b37901",
  null
  
)

export default component.exports